/**
 * Helpers cho luồng R2 (Vòng Bán kết) — pure functions, test được.
 *
 * Logic ở đây phải match đúng business rule BE:
 *  - semifinal (R2) bốc thăm đúng 4 đội
 *  - final (R3) bốc thăm đúng 2 đội
 *  - publish-round: memorial→top4 (semifinal), semifinal→top2 (final)
 */

export type RoundType =
  | 'training'
  | 'memorial'
  | 'semifinal'
  | 'final'
  | string  // tolerate unknown values from BE

/**
 * Trả về số đội bắt buộc cho bracket draw theo round_type.
 * null = không enforce (memorial / training / unknown).
 */
export function requiredBracketTeamCount(roundType: RoundType | null | undefined): number | null {
  if (roundType === 'semifinal') return 4
  if (roundType === 'final') return 2
  return null
}

/**
 * Reason để disable nút "Bốc thăm" (null = OK, có thể bốc). Phải khớp validation BE.
 */
export function getBracketDrawBlockedReason(params: {
  caseId: string | null | undefined
  roundType: RoundType | null | undefined
  eligibleCount: number
}): string | null {
  const { caseId, roundType, eligibleCount } = params
  if (!caseId) return 'Chọn cuộc thi trước.'
  const required = requiredBracketTeamCount(roundType)
  if (required !== null && eligibleCount !== required) {
    const label = roundType === 'final' ? 'Chung kết' : 'Bán kết'
    return `Vòng ${label} phải có đúng ${required} đội (hiện ${eligibleCount}).`
  }
  if (eligibleCount < 2) return 'Cần ít nhất 2 đội để bốc thăm.'
  if (eligibleCount % 2 !== 0) return 'Số đội phải chẵn để ghép cặp.'
  return null
}

/**
 * Khi BTC publish kết quả, chọn auto top N + label vòng kế tiếp.
 * null = không hỗ trợ (chỉ memorial → bán kết, semifinal → chung kết).
 */
export function publishAutoPick(
  roundType: RoundType | null | undefined,
): { topN: number; nextLabel: string } | null {
  if (roundType === 'memorial') return { topN: 4, nextLabel: 'Vòng Bán kết' }
  if (roundType === 'semifinal') return { topN: 2, nextLabel: 'Vòng Chung kết' }
  return null
}
